import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Row } from 'angieslist-react-components';
import { get } from 'lodash';
import { analytics, Track } from 'angieslist-app-platform';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import './MiniProfile.scss';
import type { ProfileReducerState } from '../../common/profileReducer';
import type { ServiceProviderCacheState } from '../../../../app/common/serviceProvider/serviceProviderReducer';
import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';
import CoverPhotoUploader from '../../../setup/browser/components/step2/coverPhotoUploader';

/**
 * All logic for this mini profile component is pre-existing and comes from
 * src/modules/profile/browser/components/LogoUploader.js
 */

type Props = {
  serviceProviderId: string | number,
  serviceProviderProfile: ProfileReducerState,
  serviceProviderCache: ServiceProviderCacheState,
  resetCoverPhotoRenderError: () => void,
  setCoverPhotoRenderError: () => void,
  coverPhotoRenderError: Boolean,
  sizeError: Boolean,
  uuid: string,
};

class MiniProfile extends React.Component {
  componentDidMount() {
  }

  props: Props;

  render() {
    const {
      serviceProviderProfile,
      serviceProviderCache,
      serviceProviderId,
      coverPhotoRenderError,
      setCoverPhotoRenderError,
      resetCoverPhotoRenderError,
      sizeError,
      uuid,
    } = this.props;

    const { name, profileUrl } = get(serviceProviderCache, serviceProviderId, {});

    return (
      <div id="Mini-Profile-Container" >
        <Row style={{ align: 'center' }}>
          <Choose>
            <When condition={serviceProviderProfile.currentProfile.isLoading}>
              <Loader
                loading
                element={
                  <div className="text-center" style={{ margin: '3.5em auto 2.5em' }}>
                    <i className="icon icon-load icon-spin icon-3x text-primary" />
                  </div>
                }
              />
            </When>
            <When condition={!serviceProviderProfile.currentProfile.isLoading}>
              <Track>
                <CoverPhotoUploader
                  id="Edit-Profile-Logo"
                  setCoverPhotoRenderError={setCoverPhotoRenderError}
                  resetCoverPhotoRenderError={resetCoverPhotoRenderError}
                  coverPhotoRenderError={coverPhotoRenderError}
                  sizeError={sizeError}
                  businessName={name}
                  uuid={uuid}
                  cameraButtonDescription="Add profile photo"
                  isMiniprofile
                  profileUrl={profileUrl}
                  capitalizedStep="SP Profile : Edit Profile Details"
                />
              </Track>
            </When>
          </Choose>
        </Row>
      </div>
    );
  }
}

const miniProfileAnalytics = {
  page: {
    name: 'SP Profile : Edit Profile Details',
    properties: {
      ...defaultPageProps,
    },
  },
};

export default hot(module)(compose(
  analytics({ ruleset: miniProfileAnalytics }),
  connect(state => ({
    serviceProviderProfile: state.serviceProviderProfile,
    serviceProviderId: state.serviceProviderId,
    serviceProviderCache: state.serviceProviderCache,
  })),
)(MiniProfile));



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/MiniProfile.js